import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { requestOpenMessagesChannel } from '../../redux/atlasai/actions'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { dismissMessageToast } from '../../redux/ui/actions'
import { messageToasts } from '../../redux/ui/selectors'
import MessageToasts, { IProps } from './MessageToasts'

const selector = createStructuredSelector({
  toasts: messageToasts,
})
const actions = {
  dismissMessageToast,
  requestOpenMessagesChannel,
}
const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector<typeof connector, IProps, PropsFromRedux>(connector, MessageToasts)
